var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuadrillage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 4.275C1.875 3.435 1.875 3.015 2.0385 2.694C2.18231 2.41177 2.41177 2.18231 2.694 2.0385C3.015 1.875 3.435 1.875 4.275 1.875H13.725C14.565 1.875 14.985 1.875 15.306 2.0385C15.5882 2.18231 15.8177 2.41177 15.9615 2.694C16.125 3.015 16.125 3.435 16.125 4.275V13.725C16.125 14.565 16.125 14.985 15.9615 15.306C15.8177 15.5882 15.5882 15.8177 15.306 15.9615C14.985 16.125 14.565 16.125 13.725 16.125H4.275C3.435 16.125 3.015 16.125 2.694 15.9615C2.41177 15.8177 2.18231 15.5882 2.0385 15.306C1.875 14.985 1.875 14.565 1.875 13.725V4.275Z",
    stroke: "#677788",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 16.125L9.375 4.875M16.125 3.375L1.875 6.375M9.375 11.2725C9.375 12.891 7.77 14.028 7.07025 14.4473C6.97359 14.5055 6.86287 14.5363 6.75 14.5363C6.63713 14.5363 6.52641 14.5055 6.42975 14.4473C5.73 14.028 4.125 12.891 4.125 11.2718C4.125 9.684 5.397 8.625 6.75 8.625C8.15025 8.625 9.375 9.684 9.375 11.2725Z",
    stroke: "#677788"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12C7.16421 12 7.5 11.6642 7.5 11.25C7.5 10.8358 7.16421 10.5 6.75 10.5C6.33579 10.5 6 10.8358 6 11.25C6 11.6642 6.33579 12 6.75 12Z",
    fill: "#677788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadrillage);
export default __webpack_public_path__ + "static/media/quadrillage.847d2ab1b9ddb7299a95749e3518812c.svg";
export { ForwardRef as ReactComponent };